import * as Models from "../../ts/rlAdmin.models";
import * as moment from "moment";
import { ReportService } from "../../services/report-service";
import { NotifyService } from "../../services/notify-service";
import { EntityService } from "../../services/entity-service";
import { AdminService } from "../../services/admin-service";
import { ICharacteristicMetaData, ICustomUserColumns } from "../../ts/rlAdmin.models";
import { RightsFilterService } from "../../services/rights-filter-service";

export class AvailabilityController {
    static $inject = ["$scope", "$filter", "$interval", "$window", "reportService", "notifyService", "entityService", "adminService", "rightsFilterService"];

    loading: boolean;
    filterModel: Models.IRightsFilterModel;
    searchMode: string;
    propertyRows: Models.IGetAvailsWindowAssetsRow[];
    propertyExportUrl: string;
    page: number;
    pageSize: number;
    customColumns: ICustomUserColumns;
    public get pageCount(): number {
        return Math.ceil(this.total / this.pageSize);
    };
    total: number;
    public get hasRows(): boolean {
        var output = false;
        switch (this.searchMode) {
            case "properties":
                output = !_.isEmpty(this.propertyRows);
                break;
            default:
                output = !_.isEmpty(this.windowRows);
                break;
        }
        return output;
    }
    windowRows: Models.IGetAvailsWindowsRow[];
    exportJobModal: boolean = false;
    exportJobID: string;
    exportJobTitle: string;
    exportJobStatus: string;
    exportIntervalPromise: ng.IPromise<any>;
    public hasSearched: boolean = false;

    constructor(
        private $scope: ng.IScope,
        private $filter: ng.IFilterService,
        private $interval: ng.IIntervalService,
        private $window: ng.IWindowService,
        private reportService: ReportService,
        private notifyService: NotifyService,
        private entityService: EntityService,
        private adminService: AdminService,
        private rightsFilterService: RightsFilterService) {

        this.loading = false;
        this.page = 1;
        this.pageSize = 25;


        this.searchMode = "windows";

        this.SetupParameters();

        $scope.$watch(() => this.customColumns, (newValue, oldValue) => {
            if (newValue && newValue != oldValue && this.hasSearched) {
                if (this.searchMode == "properties") {
                    this.SearchProperties();
                }
                else if (this.searchMode == "windows") {
                    this.SearchWindows();
                }
            }
        }, true);
    }

    SetupParameters() {
        // start date defaults to today
        var startDate = moment()
            .subtract(moment.duration({ 'months': 1 }))
            .format("L");
        // end date defaults to a year after today
        var endDate = moment()
            .subtract(moment.duration({ 'months': 1 }))
            .add(moment.duration({ 'years': 1 }))
            .format("L");

        this.filterModel = this.rightsFilterService.GetCachedFilter({
            startDate: startDate,
            endDate: endDate,
            exactInd: "0",
            exclusive: "1",
            selectedMediaIDs: [],
            selectedTerritoryIDs: [],
            selectedLanguageIDs: [],
            selectedChannelIDs: [],
            selectedChannelLeafIDs: [],
            selectedAssetFacet: {},
            selectedLanguageLeafIDs: [],
            selectedMediaLeafIDs: [],
            selectedTerritoryLeafIDs: [],
            selectedRightSetTemplateIDs: [],
            show: {},
            rollup: 0,
            isAssetAvailable: true,
            isTupleAvailable: true,
            isScoped: true,
            matchType: 1,
            minDays: null,
            isWindowed: false,
            dimFormat: { "1": true, "2": true, "3": true, "4": true }
        });
    }

    Export() {
        var clientStartDate = this.filterModel.startDate;
        var clientEndDate = this.filterModel.endDate;

        //Get the user's date format and then turn it back into mm/dd/yyyy
        var dateFormat: string = moment.localeData()["_longDateFormat"]["L"];
        var startDate = moment(clientStartDate, dateFormat).format('MM/DD/YYYY')
        var endDate = moment(clientEndDate, dateFormat).format('MM/DD/YYYY')
        var dimFormatFlag = 0;
        for (const dim of [1, 2, 3, 4]) {
            if (this.filterModel.dimFormat[dim]) {
                dimFormatFlag = dimFormatFlag | (1 << dim)
            }
        }

        switch (this.searchMode) {
            case "properties":
                this.notifyService.startProgress();
                this.reportService.exportAvailabilityWindowAssets(
                    this.filterModel.selectedAssetRecordIDs,
                    this.filterModel.selectedAssetFacet,
                    startDate,
                    endDate,
                    this.filterModel.selectedMediaLeafIDs,
                    this.filterModel.selectedTerritoryLeafIDs,
                    this.filterModel.selectedLanguageLeafIDs,
                    this.filterModel.selectedChannelLeafIDs,
                    this.filterModel.exclusive != "" ? _.parseInt(this.filterModel.exclusive) == 1 : true,
                    _.parseInt(this.filterModel.exactInd) == 1,
                    this.filterModel.isWindowed,
                    this.filterModel.isAssetAvailable,
                    this.filterModel.minDays,
                    this.filterModel.matchType,
                    this.customColumns.columns)
                    .then((result) => {
                        alert("An email with a link to download this export has been sent to your email address.");
                        this.notifyService.endProgress();
                    });
                break;
            default: // "windows"
                this.notifyService.startProgress();
                this.reportService.exportAvailabilityWindows(
                    this.filterModel.selectedAssetRecordIDs,
                    this.filterModel.selectedAssetFacet,
                    startDate,
                    endDate,
                    this.filterModel.selectedMediaLeafIDs,
                    this.filterModel.selectedTerritoryLeafIDs,
                    this.filterModel.selectedLanguageLeafIDs,
                    this.filterModel.selectedChannelLeafIDs,
                    this.filterModel.exclusive != "" ? _.parseInt(this.filterModel.exclusive) == 1 : true,
                    _.parseInt(this.filterModel.exactInd) == 1,
                    this.filterModel.isWindowed,
                    this.filterModel.isAssetAvailable,
                    this.filterModel.isTupleAvailable,
                    this.filterModel.isScoped,
                    this.filterModel.rollupDim,
                    this.filterModel.minDays,
                    this.filterModel.matchType,
                    this.customColumns.columns,
                    this.filterModel.truncateWindows,
                    dimFormatFlag)
                    .then((result) => {
                        alert("An email with a link to download this export has been sent to your email address.");
                        this.notifyService.endProgress();
                    });
                break
        }
    }

    UpdateCSVExportProgress() {
        this.adminService.getJobState(this.exportJobID)
            .then((result) => {
                if (result.status == "Done" || result.status == "Failed" || result.status == "Cancelled") {
                    this.$interval.cancel(this.exportIntervalPromise);
                    if (result.status == "Done" && result.progressResultData != null) {
                        this.exportJobModal = false;
                    }
                    this.notifyService.endProgress();
                }
            });
    }

    SearchProperties() {
        this.searchMode = "properties";
        this.loading = true;
        this.hasSearched = true;
        this.notifyService.startProgress();

        var clientStartDate = this.filterModel.startDate;
        var clientEndDate = this.filterModel.endDate;

        //Get the user's date format and then turn it back into mm/dd/yyyy
        var dateFormat: string = moment.localeData()["_longDateFormat"]["L"];
        var startDate = moment(clientStartDate, dateFormat).format('MM/DD/YYYY')
        var endDate = moment(clientEndDate, dateFormat).format('MM/DD/YYYY')

        this.reportService.getAvailabilityWindowAssets(
            this.filterModel.selectedAssetRecordIDs,
            this.filterModel.selectedAssetFacet,
            startDate,
            endDate,
            this.filterModel.selectedMediaLeafIDs,
            this.filterModel.selectedTerritoryLeafIDs,
            this.filterModel.selectedLanguageLeafIDs,
            this.filterModel.selectedChannelLeafIDs,
            this.filterModel.exclusive != "" ? _.parseInt(this.filterModel.exclusive) == 1 : true,
            _.parseInt(this.filterModel.exactInd) == 1,
            this.filterModel.isWindowed,
            this.filterModel.isAssetAvailable,
            this.filterModel.minDays,
            this.filterModel.matchType,
            (this.page - 1) * this.pageSize,
            this.pageSize,
            this.customColumns.columns)
            .then((result) => {
                return this.reportService.getBackgroundReportResults<{ total: number, rows: Models.IGetAvailsWindowAssetsRow[] }>(result.reportID)
                    .then((data) => {
                        this.propertyRows = data.rows;
                        this.total = data.total;
                    })
                    .catch((reason) => {
                        this.notifyService.notifyError(reason);
                        this.propertyRows = [];
                        this.total = 0;
                    });
            })
            .finally(() => {
                this.loading = false;
                this.notifyService.endProgress();
            });
    }

    SearchWindows() {
        this.searchMode = "windows";
        this.loading = true;
        this.hasSearched = true;
        this.notifyService.startProgress();

        var clientStartDate = this.filterModel.startDate;
        var clientEndDate = this.filterModel.endDate;

        //Get the user's date format and then turn it back into mm/dd/yyyy
        var dateFormat: string = moment.localeData()["_longDateFormat"]["L"];
        var startDate = moment(clientStartDate, dateFormat).format('MM/DD/YYYY')
        var endDate = moment(clientEndDate, dateFormat).format('MM/DD/YYYY')

        var dimFormatFlag = 0;
        for (const dim of [1, 2, 3, 4]) {
            if (this.filterModel.dimFormat[dim]) {
                dimFormatFlag = dimFormatFlag | (1 << dim)
            }
        }

        this.reportService.getAvailabilityWindows(
            this.filterModel.selectedAssetRecordIDs,
            this.filterModel.selectedAssetFacet,
            startDate,
            endDate,
            this.filterModel.selectedMediaLeafIDs,
            this.filterModel.selectedTerritoryLeafIDs,
            this.filterModel.selectedLanguageLeafIDs,
            this.filterModel.selectedChannelLeafIDs,
            this.filterModel.exclusive != "" ? _.parseInt(this.filterModel.exclusive) == 1 : true,
            _.parseInt(this.filterModel.exactInd) == 1,
            this.filterModel.isWindowed,
            this.filterModel.isAssetAvailable,
            this.filterModel.isTupleAvailable,
            this.filterModel.isScoped,
            this.filterModel.rollupDim,
            this.filterModel.minDays,
            this.filterModel.matchType,
            this.filterModel.truncateWindows,
            dimFormatFlag,
            (this.page - 1) * this.pageSize,
            this.pageSize,
            this.customColumns.columns)
            .then((result) => {
                return this.reportService.getBackgroundReportResults<{ total: number, rows: Models.IGetAvailsWindowsRow[] }>(result.reportID)
                    .then((data) => {
                        this.windowRows = data.rows;
                        this.total = data.total;
                    })
                    .catch((reason) => {
                        this.notifyService.notifyError(reason);
                        this.windowRows = [];
                        this.total = 0;
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            })
            .finally(() => {
                this.notifyService.endProgress();
            });
    }

    Search() {
        switch (this.searchMode) {
            case "properties":
                this.SearchProperties();
                break;
            default: // "windows"
                this.SearchWindows();
                break
        }
    }

    Clear() {
        this.propertyRows = [];
        this.windowRows = [];
        this.total = 0;
    }

    PageChanged(page: number) {
        this.page = page;
        this.Search();
    }

    PageSizeChanged(pageSize: number) {
        this.page = 1;
        this.pageSize = pageSize;
        this.Search();
    }

    FormatDimBranches(branchValues: string[]) {
        if (branchValues[1] == "_excluding_") {
            return `${branchValues[0]}, <em>Excluding:</em> ${_.drop(branchValues, 2).join(", ")}`;
        } else {
            return branchValues.join(", ")
        }
    }

    FormatDimBranchesNoHTML(branchValues: string[]) {
        if (branchValues[1] == "_excluding_") {
            return `${branchValues[0]}, Excluding: ${_.drop(branchValues, 2).join(", ")}`;
        } else {
            return branchValues.join(", ")
        }
    }
}
